export { default } from '@mui/base/TextareaAutosize';